import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "./section1.css";
import ImagemCapa from "../../assets/images/capa.png";

function Section1() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <section className="container-fluid px-2 px-md-4 px-xl-5 mt-3 mt-md-4 section1">
      {/* Versão Mobile */}
      <div
        className="card d-block d-md-none rounded-3 overflow-hidden sombra hero-card-mobile border-0 position-relative"
        data-aos="fade-up"
      >
        <img
          src={ImagemCapa}
          className="card-img hero-img-mobile brilho-40"
          alt="Antonio Saldanha Advocacia - Advogado trabalhando com compromisso e ética"
          fetchPriority="high"
          width="600"
          height="400"
        />
        <div className="card-img-overlay d-flex flex-column align-items-center justify-content-center text-center p-4 hero-overlay-mobile">
          <span className="badge badge-dourado mb-2">
            Advocacia Estratégica
          </span>
          <h1 className="text-white titulo-hero-mobile">
            ANTONIO SALDANHA ADVOCACIA
          </h1>
          <p className="text-white-50 texto-hero-mobile my-3">
            Direito com empatia, integridade e valores. Respeitar você é o
            primeiro passo.
          </p>
          <div className="d-flex flex-column gap-2 w-100 px-3">
            <a
              href="https://wa.me/5511954242066"
              target="_blank"
              rel="noopener noreferrer"
              className="btn botao-dourado w-100"
            >
              Fale pelo WhatsApp
            </a>
            <Link
              to="/sobre-nos"
              className="btn btn-outline-light rounded-1 py-2 w-100 text-uppercase fw-semibold font-sm"
            >
              Sobre Nós
            </Link>
          </div>
        </div>
      </div>

      {/* Versão Desktop */}
      <div className="d-none d-md-flex position-relative hero-wrapper-desktop overflow-hidden rounded-3">
        <div className="imagem-hero-container" data-aos="fade-right">
          <img
            src={ImagemCapa}
            alt="Antonio Saldanha Advocacia - Atuação jurídica com ética e transparência em São Paulo"
            className="hero-img-desktop brilho-60"
            fetchPriority="high"
            width="1200"
            height="600"
          />
          <div className="hero-img-gradient"></div>
        </div>

        <div
          className="d-flex flex-column justify-content-center forma-hero-desktop p-4 p-xl-5"
          data-aos="fade-left"
        >
          <div className="hero-content-inner text-start">
            <span className="badge badge-dourado mb-3">
              Excelência Jurídica & Atendimento Humanizado
            </span>
            <h1 className="titulo-hero-desktop mb-3">
              ANTONIO SALDANHA ADVOCACIA
            </h1>
            <p className="texto-hero-desktop mb-4">
              Direito com empatia, integridade e valores. Respeitar você é o
              primeiro passo.
            </p>
            <p className="texto-hero-sub-desktop mb-4 d-none d-lg-block text-muted">
              Advocacia estratégica, transparente e de alta performance para
              proteger seus direitos e impulsionar seus objetivos com segurança
              jurídica.
            </p>

            <div className="d-flex flex-wrap gap-3 align-items-center">
              <a
                href="https://wa.me/5511954242066"
                target="_blank"
                rel="noopener noreferrer"
                className="btn botao-dourado text-nowrap"
              >
                Falar pelo WhatsApp
              </a>

              <Link
                to="/sobre-nos"
                className="btn botao-escuro-padrao text-nowrap"
              >
                Saiba mais sobre o escritório
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section1;
